import { Navigate } from "react-router-dom";
import useModules from "../../../hooks/useModules";
import { useIsCmmsEnabled } from "../cmmsFeature";

/*
 * Route guard for the CMMS pages.
 *
 * Hiding the menu is not enough on its own — a bookmark or a pasted URL would still open an
 * unreleased module in a production OEE install. This closes that door.
 *
 * Renders nothing while the modules are still loading rather than redirecting: /api/modules is
 * still in flight on first paint, so the answer is undefined, and redirecting on that would
 * bounce a legitimate CMMS user off their own page on every hard refresh.
 */
export default function CmmsFeatureRoute({ element, fallback = <Navigate to="/" /> }) {
  const modulesQuery = useModules();
  const cmmsEnabled = useIsCmmsEnabled();

  if (modulesQuery.isLoading) return null;

  return cmmsEnabled ? element : fallback;
}
